export { localitiesSlice } from './localitiesSlice';
export { localitiesOp } from './operations';
export { localitiesSel } from './selectors';
